(function ( $ ) {

    $(document).ready(function () {

        var $heroImgCell, $heroTextCell, $headerBg, $headerAccent, $headerImg;

        $('.page-header .radio-align').on('change',function (e) {
            var $this = $(this);
            $heroImgCell = $this.closest('.image-position').siblings('.header-animation');
            var val = $this.val();
            if ( typeof val !== "undefined" ) { $heroImgCell.css('text-align', val); }
        });

        $('.page-header .range-slider').on('input',function (e) {
            var $this = $(this);
            var initialVal = $this.val();
            var leftCellVal = initialVal + '%';
            var rightCellVal = (100 - initialVal) + '%';

            $this.siblings('.cur-value').html( leftCellVal ); // updating .badge element value for current range-slider

            if ( typeof e.originalEvent !== "undefined" ) {
                // check if event was native ( in another words - was NOT triggered by some js code)

                if ( $this.hasClass('left-width') ) {
                    $heroImgCell = $this.closest('.image-position').siblings('.header-animation');
                    $heroTextCell = $this.closest('.image-position').siblings('.header-title');

                    $heroImgCell.css('width', leftCellVal); // updating width css property for header-animation cell
                    $heroTextCell.css('width', rightCellVal); // updating width css property for header-animation cell
                }
                else if ( $this.hasClass('bg-width') ) {
                    $headerBg = $this.closest('.page-header').find('.header-bg');
                    $headerAccent = $this.closest('.page-header').find('.header-accent');

                    $headerBg.css('width', initialVal + '%'); // updating width css property for header-bg
                    $headerAccent.css('left', 'calc(' + initialVal + '% - 2px)'); // updating left css property for header-accent
                }
                else if ( $this.hasClass('img-max-width') ) {
                    $headerImg = $this.closest('.page-header').find('.page-header__img');

                    $headerImg.css('max-width', initialVal + '%'); // updating max-width css property for image
                }
            }
        });

    });
})( jQuery )
